import type { AdminMallOrder, MallOrder } from '@/api/mallOrder'

export function listTaxInvoiceIssues(order: Pick<
  MallOrder,
  'bizName' | 'bizNum' | 'taxEmail' | 'bizCert'
>): string[] {
  const issues: string[] = []
  const bizName = String(order.bizName || '').trim()
  const bizNum = String(order.bizNum || '').replace(/\D/g, '')
  const taxEmail = String(order.taxEmail || '').trim().toLowerCase()
  const bizCert = String(order.bizCert || '').trim()

  if (!bizName) issues.push('상호가 입력되지 않았습니다.')
  if (bizNum.length < 10) issues.push('사업자번호가 올바르지 않습니다.')
  if (!taxEmail) issues.push('세금계산서 수신 이메일이 없습니다.')
  if (!bizCert) issues.push('사업자등록증이 첨부되지 않았습니다.')

  return issues
}

export function buildTaxRejectSms(orderCode: string, issues: string[]): string {
  return [
    '[장기요양지원센터·함우리몰]',
    '',
    `주문 ${orderCode} 세금계산서 발행 요청이 반려되었습니다.`,
    '',
    '아래 내용을 확인해 주세요.',
    ...issues.map((item) => `- ${item}`),
    '',
    '주문 상세에서 사업자등록증·이메일을 등록한 뒤 「세금계산서 발행 요청」을 다시 해 주세요.',
  ].join('\n')
}

export function orderHasDelivered(order: AdminMallOrder): boolean {
  const statuses =
    order.items?.map((item) => item.status) ?? order.itemStatuses ?? []
  return statuses.some((status) => status === 'DELIVERED' || status === 'DONE')
}
